import { render, staticRenderFns } from "./nova_prod_serv.vue?vue&type=template&id=4ddca75e&scoped=true&"
import script from "./nova_prod_serv.vue?vue&type=script&lang=js&"
export * from "./nova_prod_serv.vue?vue&type=script&lang=js&"
import style0 from "./nova_prod_serv.vue?vue&type=style&index=0&id=4ddca75e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddca75e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VForm,VProgressCircular,VSwitch,VTextField})
